// icons
import { LoadingButton } from '@mui/lab';
import { Chip, Divider, Stack, Switch, Typography } from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import { UseFormReturn } from 'react-hook-form/dist/types';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '100%',
    padding: theme.spacing(1, 4),
    borderLeft: `dashed 1px ${theme.palette.divider}`,
  },
}));

// ----------------------------------------------------------------------

type Props = {
  form: UseFormReturn;
};

export default function FormSummary({ form }: Props) {
  const {
    register,
    formState: { errors, isValid, isSubmitSuccessful },
  } = form;

  return (
    <RootStyle>
      <Stack spacing={2} direction="row" alignItems="center" sx={{ mb: 5 }}>
        <Chip label="3" />
        <Typography variant="h5">Innsending</Typography>
      </Stack>

      <Stack spacing={2.5}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Ønsker gratis befaring
          </Typography>
          <Switch {...register('inspection')} color="success" defaultChecked />
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />
      </Stack>

      <LoadingButton
        loading={isSubmitSuccessful && isValid}
        type="submit"
        fullWidth
        size="large"
        variant="contained"
        sx={{ mt: 5, mb: 3 }}
      >
        Send skjema
      </LoadingButton>
      <Typography variant="caption" sx={{ color: 'text.disabled' }}>
        *obligatoriske felt.
      </Typography>
    </RootStyle>
  );
}
